import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { ChipModule } from "primeng/chip";
import { EditorModule } from "primeng/editor";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { RippleModule } from "primeng/ripple";
import { ContaListarComponent } from "./conta-listar.component";
import { ContaListarRoutingModule } from "./conta-listar-routing.module";

import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { SplitButtonModule } from 'primeng/splitbutton';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from "primeng/progressspinner";


@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        InputTextModule,
        InputTextareaModule,
        FileUploadModule,
        RippleModule,        
        ChipModule,
        TableModule,
        EditorModule,
        ContaListarRoutingModule,
        HttpClientModule,        
        TooltipModule,
        DividerModule,
        SplitButtonModule,
        ConfirmDialogModule,
        MessagesModule,
        ProgressSpinnerModule
    ],
    providers: [ConfirmationService],
    declarations: [ContaListarComponent]
})
export class ContaListarModule { }
